import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Layout from '../components/Layout';
import { useFetchNotices } from '../hooks/useAppInit';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/NormalNoticeAll.css';

const fallback = [
  { _id: 'n1', title: 'Annual Sports Day – 15 June 2025', date: '2025-05-20', noticeType: 'General' },
  { _id: 'n2', title: 'Parent-Teacher Meeting scheduled for July 20, 2025', date: '2025-05-18', noticeType: 'PTM' },
  { _id: 'n3', title: 'Summer Vacation from May 25 to June 29, 2025', date: '2025-05-15', noticeType: 'Holiday' },
  { _id: 'a1', title: 'Admissions Open for Session 2025-26 – Classes Nursery to XII', date: '2025-04-01', noticeType: 'Admission' },
  { _id: 'a2', title: 'Last Date for Admission Registration: 30 June 2025', date: '2025-04-10', noticeType: 'Admission' },
  { _id: 'n4', title: 'Science Exhibition – July 5, 2025', date: '2025-05-12', noticeType: 'Event' },
];

export default function NormalNoticeAll() {
  useFetchNotices();
  const notices = useSelector((state) => state.notices.notices);
  const items = notices.length > 0 ? notices : fallback;
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');

  const types = ['All', 'Admission', 'General', 'Exam', 'Holiday', 'PTM', 'Event'];
  const filtered = items.filter((n) => {
    const matchSearch = n.title.toLowerCase().includes(search.toLowerCase());
    const matchType = filter === 'All' || n.noticeType === filter;
    return matchSearch && matchType;
  });

  return (
    <Layout bannerTitle="All Notices">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Notices & Circulars" />
          <div className="notice-all-toolbar mt-4">
            <input type="text" className="form-control" placeholder="Search notices..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <div className="notice-filter-row">
              {types.map((t) => (
                <button key={t} className={`cal-filter-btn${filter === t ? ' active' : ''}`} onClick={() => setFilter(t)}>{t}</button>
              ))}
            </div>
          </div>
          <div className="notice-all-list mt-4">
            {filtered.map((n) => (
              <div key={n._id} className="notice-all-item">
                <div className="notice-all-icon">
                  <i className="fas fa-file-alt"></i>
                </div>
                <div className="notice-all-content">
                  <Link to={`/notice/${n._id}`} className="notice-all-title">{n.title}</Link>
                  <div className="notice-all-meta">
                    <span className={`notice-type-badge type-${n.noticeType?.toLowerCase()}`}>{n.noticeType}</span>
                    <span className="notice-all-date"><i className="fas fa-calendar me-1"></i>{moment(n.date || n.createdAt).format('DD MMM YYYY')}</span>
                  </div>
                </div>
                {n.file && (
                  <a href={n.file} target="_blank" rel="noreferrer" className="notice-download-btn">
                    <i className="fas fa-download"></i>
                  </a>
                )}
              </div>
            ))}
            {filtered.length === 0 && <div className="text-center py-5 text-muted">No notices found.</div>}
          </div>
        </div>
      </section>
    </Layout>
  );
}
